import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  IndicatorByService,
  IndicatorSectionKey,
  IndicatorWithUpdate,
} from '../../../../ReportBuilder/Components/ImpactIndicator/utils';
import SummaryIcon from '../../../../ReportBuilder/Components/ImpactSummary/SummaryIcon';
import { mergeClassNames } from 'shared/utils/mergeClassNames';
import StagesModal from '../../../../ReportBuilder/Components/ImpactIndicator/Stages/StagesModal';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { HandleAddIndicatorData } from './ImpactTableStage';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface ImpactAddStageProps {
  stageName: string;
  sectionKey: IndicatorSectionKey;
  allIndicators: IndicatorByService;
  handleAddIndicator: (
    sectionKey: IndicatorSectionKey,
    indicator: IndicatorWithUpdate,
    data: HandleAddIndicatorData,
  ) => unknown;
}

const StyledDiv = styled.div`
  .add-indicator-disabled {
    background-color: ${COLORS.grayLight};
    * {
      color: ${COLORS.greyDark};
    }
  }
`;

const ImpactAddStage: React.FC<ImpactAddStageProps> = ({
  sectionKey,
  stageName,
  allIndicators,
  handleAddIndicator,
}) => {
  const indicators = allIndicators[sectionKey];
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  const handleAdd = useCallback(
    (i: IndicatorWithUpdate) => {
      handleAddIndicator(sectionKey, i, {
        updatedText: '',
        measurement: '',
        forecast: undefined,
        finalForecast: undefined,
        file: undefined,
      });
      setOpen(false);
    },
    [sectionKey, setOpen, handleAddIndicator],
  );

  const disabled = indicators.length === 0;

  return (
    <>
      <SummaryIcon
        text={stageName}
        sectionKey={sectionKey}
        className="stage-column"
      />
      <StyledDiv className="metric-column">
        <StagesModal
          open={open}
          header={stageName}
          sectionKey={sectionKey}
          indicators={indicators}
          marginTop={SPACERS.small}
          handleAdd={handleAdd}
          handleClose={handleClose}
          handleOpen={handleOpen}
          className={mergeClassNames(
            'add-indicator-modal',
            disabled && 'add-indicator-disabled',
          )}
          disabled={disabled}
          buttonText={
            disabled
              ? `${stageName} stage is not available for this model`
              : `Add ${stageName} by adding an indicator`
          }
          selectedIndicators={[]}
        />
      </StyledDiv>
      <div
        className={mergeClassNames(
          'results-column',
          sectionKey === 'succeed' && 'bottom-right-radius',
        )}
      />
    </>
  );
};

export default ImpactAddStage;
